import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Unmasks inputs as Numbers. For use with textMask.
 * Based on source from angular2-text-mask GH issue: https://github.com/text-mask/text-mask/issues/109#issuecomment-427590557
 */
@Directive({
  selector: '[numberInput]',
  standalone: false,
})
export class NumberInputDirective {
  constructor(private elementRef: ElementRef, private model: NgControl) {}

  @HostListener('input')
  inputChange() {
    const newValue = this.unMask();
    this.model.control?.setValue(newValue, {
      emitEvent: true,
      emitModelToViewChange: false,
      emitViewToModelChange: false,
    });
  }

  @HostListener('blur')
  onBlur() {
    this.elementRef.nativeElement.value = this.addDecimals();
    const newValue = this.unMask();
    this.model.control?.setValue(newValue, {
      emitEvent: true,
      emitModelToViewChange: false,
      emitViewToModelChange: false,
    });
  }

  @HostListener('focus')
  onFocus() {
    if (this.model.control?.value === 0)
      this.elementRef.nativeElement.setSelectionRange(
        0,
        this.elementRef.nativeElement.value.length
      );
    else
      this.elementRef.nativeElement.setSelectionRange(
        this.elementRef.nativeElement.value.length - 3,
        this.elementRef.nativeElement.value.length - 3
      );
  }

  addDecimals() {
    const value = String(this.elementRef.nativeElement.value);
    const arrayNum = value.split('.');
    arrayNum[0] = arrayNum[0].length > 0 ? arrayNum[0] : '';
    arrayNum[1] =
      arrayNum && arrayNum.length === 2
        ? ('.' + arrayNum[1].replace('_', '') + '00').substring(0, 3)
        : '';
    return arrayNum[0] + arrayNum[1];
  }

  unMask() {
    const value = this.elementRef.nativeElement.value.replace(/[^\d.-]/g, '', '');
    if (value === null || value === undefined || value === '') {
      return undefined;
    }
    return Number(value);
  }
}
